export default function SerpReviews() {
  const SELECTOR_REVIEW_SECTION = '.js-serp-reviews';
  const SELECTOR_REVIEW_TEXT = '.js-serp-review-text';

  const onShowMore = (event) => {
    const $clickedShowMore = $(event.currentTarget);
    $clickedShowMore.addClass('hid');
    const $parent = $clickedShowMore.parent();
    const text = $parent.find('blockquote');
    const showLessButton = $parent.find('.ao-show-less');
    $(text).removeClass('ao-truncated');
    $(showLessButton).removeClass('hid');
  };

  const onShowLess = (event) => {
    const $clickedShowLess = $(event.currentTarget);
    $clickedShowLess.addClass('hid');
    const $parent = $clickedShowLess.parent();
    const text = $parent.find('blockquote');
    const showMoreButton = $parent.find('.ao-show-more');
    $(text).addClass('ao-truncated');
    $(showMoreButton).removeClass('hid');
  };
  const addShowMoreAndLessFunctionality = (element) => {
    const $showMoreButton = $(element).parent().find('.ao-show-more');
    const $showLessButton = $(element).parent().find('.ao-show-less');

    $showMoreButton.on('click', (event) => onShowMore(event));
    $showLessButton.on('click', (event) => onShowLess(event));
  };
  this.initiate = () => {
    const $reviewTexts = $(SELECTOR_REVIEW_SECTION).find(SELECTOR_REVIEW_TEXT);

    if ($reviewTexts.length) {
      $reviewTexts.each((index, element) => {
        const $quote = $(element).find('blockquote');
        addShowMoreAndLessFunctionality($quote);
      });
    }
  };
}
